// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import axios from "axios";

const firebaseConfig = {
  apiKey: "AIzaSyA8YIJpwmcFTm5d1OdPufQnk2MTHFrIjQs",
  authDomain: "kg-maintenance.firebaseapp.com",
  projectId: "kg-maintenance",
  storageBucket: "kg-maintenance.firebasestorage.app",
  messagingSenderId: "1015676769493",
  appId: "1:1015676769493:web:08d4753317f35772b4fe5c",
  measurementId: "G-X9YFRC0F2H",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
let messaging = null;
if(typeof window !== "undefined" && window.isSecureContext && "serviceWorker" in navigator) {
  messaging = getMessaging(app);
}

export const requestPermissionAndSendToken = async () => {
  try {
    // Step 1: Register the service worker
    if(!messaging) return;
    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );

    // Step 2: Request permission from the user
    const permission = await Notification.requestPermission();
    if (permission === "default") {
      // Step 3: Generate FCM token with the registered service worker
      const token = await getToken(messaging, {
        vapidKey:
          "BPZaOYO1Gr7QKTkIfDGvNFGriduCtS6GTJHcNB93n9b2XwSAncSw2Hvi804JBExxr9QGUoP_Th26Tmd5cOP089A",
        serviceWorkerRegistration: registration,
      });

      if (token) {
        localStorage.setItem("fcmToken", token);
      } else {
        console.warn(
          "No registration token available. Request permission to generate one."
        );
      }
    } else {
      console.warn("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
  }
};
